'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PageRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageRemote = exports.PageRemote = {
    fetchAboutData: function fetchAboutData(_ref) {
        var deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>spapage/about' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    },
    fetchHomeData: function fetchHomeData(_ref2) {
        var deployment = _ref2.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({ deployment: deployment, path: '<ITEM-API>spapage/home' });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/page.js
// module id = 3XgF
// module chunks = 60